<template>
  <div :v-loading.sync="loading">
    <el-tabs
        v-model="show"
    >
      <el-tab-pane
          label="用户列表"
          name="TABLE"
      >
        <user-list ref="user-table" @edit="showForm"></user-list>
      </el-tab-pane>
      <el-tab-pane
          label="新增用户"
          name="FORM"
      >
        <user-form :model="formModel" @close="showTable"></user-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UserList from "@/components/user/UserList";
import UserForm from "@/components/user/UserForm";
import User from "@/models/User";

export default {
  name: "UserManagement",
  components: {UserForm, UserList},
  data() {
    return {
      loading: false,
      show: 'TABLE',
      formModel: new User()
    }
  },
  methods: {
    showTable() {
      this.show = 'TABLE'
      this.$refs['user-table'].refreshTable()
      this.formModel = new User()
    },
    showForm(item) {
      this.formModel = new User(item)
      this.show = 'FORM'
    }
  }
}
</script>

<style scoped>

</style>
